/**
 * The top bar's icon button, as every figure draws it (Story #5648, round 7).
 *
 * kit.css, the shared shell stylesheet the twelve approved figures all link:
 *
 *   .tb-ic{width:34px;height:34px;border-radius:9px;background:#fff;
 *          border:1px solid var(--line);display:flex;align-items:center;
 *          justify-content:center;color:var(--iflow-700);position:relative}
 *
 * NOT ONE figure overrides it — checked across screen-S1..S7, S4b, C1, C2, C4
 * and C5. The personal figures (S1-S4b, C2, C5) draw help and the bell in it;
 * the aggregator figures (C1, S5, S6, S7) draw the magnifier in it too; C4 —
 * the organisation figure — draws help and the bell in it beside a search box.
 * So it is one rule for all three families, which is why it lives in one
 * constant rather than being retyped per call site.
 *
 * Live drew help and the bell as bare glyphs on a `p-2` hit area with no box at
 * all — the gap every review since round 1 has recorded and none had charged.
 *
 * It is a plain string, not a component, because the two call sites (TopBar's
 * help button, NotificationBell's trigger) need their own handlers, their own
 * children and — in the bell's case — a positioned dot inside the box. A shared
 * wrapper component would have to forward all of that; a shared class does not.
 * It lives in its own module rather than in TopBar because TopBar imports
 * NotificationBell, and a constant exported the other way would close the loop.
 */
export const TB_IC =
  'relative flex h-[34px] w-[34px] shrink-0 items-center justify-center rounded-lg border border-slate-200 bg-white transition-colors'
